module.exports = __webpack_public_path__ + "static/media/bm.422bfdbb.svg";